// This file is automatically generated. DO NOT EDIT.

/* eslint-disable */

export const PACKAGE_INFO = {
  "name": "@gmb/bitmark-parser-generator",
  "version": "4.5.0",
  "author": "Get More Brain Ltd",
  "license": "ISC",
  "description": "A bitmark parser and generator using Peggy.js"
};
